import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { CurrencyDisplay } from '@/components/Currency';
import { usePriceToDinero } from '@/utilities/priceToDinero';

interface TotalAmountProps {
  total: number;
}

export const TotalAmount: React.FC<TotalAmountProps> = ({ total }) => {
  const priceToDinero = usePriceToDinero();

  // Don't render anything if total is 0
  if (total === 0) {
    return (
      <Box 
        bg="transparent"
        p="0"
        width="100%"
      >
        <Flex justify="space-between" align="center">
          <Text fontSize="lg" color="gray.600" fontWeight="bold">
            Total Amount
          </Text>
          <Text
            fontWeight="bold"
            fontSize="lg"
            color="gray.400"
          >
            $0.00
          </Text>
        </Flex>
      </Box>
    );
  }

  return (
    <Box 
      bg="transparent"
      p="0"
      width="100%"
    >
      <Flex justify="space-between" align="center">
        <Text fontSize="lg" color="gray.600" fontWeight="bold">
          Total Amount
        </Text>
        <CurrencyDisplay
          value={priceToDinero(total)}
          fontWeight="bold"
          fontSize="lg"
          color="primary.500"
        />
      </Flex>
    </Box>
  );
};